module.exports = __webpack_public_path__ + "static/media/0.046e91f7.png";